var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___M0JZaH",
};

module.exports = exports;
